import { WMSTileLayer } from "react-leaflet";

import { ExtendedWMSParams, Layer, LayerWMS } from "types";

import { useMemo } from "react";

interface Props {
  layer: Layer;
  zIndex: number;
}

export function MaskWMSLayer(props: Props) {
  const { layer, zIndex } = props;
  const params = useMemo(() => toWMSParams(layer.wms), [layer]);

  function toWMSParams(wms: LayerWMS): ExtendedWMSParams {
    return {
      format: wms.format,
      layers: wms.layers || "",
      service: "WMS",
      styles: wms.styles,
      opacity: wms.opacity || 1,
      version: "1.1.1",
      transparent: true,
      tiled: true,
    };
  }

  return <WMSTileLayer url={layer.wms.url} params={params} zIndex={zIndex} />;
}
